import { useQuery } from '@tanstack/react-query';

import getRoleList from 'Api/role/getRoleList';
import { useUserInfo } from 'Store/userInfo';

import getAllRolesResponse from './model/response/getAllRolesResponse';

const useGetAllRoles = () => {
  const { organization } = useUserInfo();

  return useQuery({
    queryKey: ['all-roles', organization?.id],
    queryFn: async () => {
      const response = await getRoleList();

      return getAllRolesResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 15 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export default useGetAllRoles;
